export enum InvoiceStatus{
    Paid = 'Paid',
    ScheduledToPay = 'Scheduled to Pay',
    PaymentInReview = 'Not Posted - Exception Review',
    PaymentOnHold = 'Contact BDM'
}
